import { LOCATION_ASSIGNMENT_ON_CHANGE } from "../actions/types";
import axios from "axios";

export const locationAssignmentOnchangeActionFunction = ({ props, value }) => {
  return {
    type: LOCATION_ASSIGNMENT_ON_CHANGE,
    payload: { props, value },
  };
};

export const locationAssignmentPOST = ({ generalToken, body }) => {
  return (dispatch) => {
    const HEADER = {
      headers: {
        authorization: "Bearer " + generalToken,
      },
    };

    const data = body;

    const RES = dispatch({
      type: "LOCATION_ASSIGNMENT_POST",
      payload: axios.post(
        "/api/LocationAssignment/LocationAssignment",
        data,
        HEADER
      ),
    });

    console.log(RES);
  };
};
